/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { cleanUp, errorOccurred, mediaRecorderInitialized, videoObjectGenerated, updateTimer } from '../../actions';
import { CLEAN_UP, COUNTDOWN_COMPLETE, SCREEN_SHARING_ENDED, STARTOVER_CLICKED, UNMOUNT_CLEAN_UP, PAUSE_CLICKED, CONTINUE_CLICKED } from '../../constants/ActionTypes';
import { translate } from '../../constants/translated/translations';
import { startMediaRecorder } from '../../core/mediaRecorder';
import Timer from '../../utils/timer';
export default function recordingMiddleware({
  onStreamInitialized
}) {
  return function ({
    dispatch,
    getState
  }) {
    const timer = new Timer(time => dispatch(updateTimer(time)));
    const fileSuccess = blob => {
      const src = window.URL.createObjectURL(blob);
      dispatch(videoObjectGenerated(src, blob));
    };
    return next => action => {
      const state = getState();
      switch (action.type) {
        case COUNTDOWN_COMPLETE:
          startMediaRecorder({
            stream: state.streamMerger.getStream(),
            onMediaRecorderInit: (mediaRecorder, encodedStream, mediaContainerType) => {
              onStreamInitialized(encodedStream, mediaContainerType, fileSuccess);
              dispatch(mediaRecorderInitialized(mediaRecorder));
            },
            fileSuccess,
            fileError: err => {
              console.error('Error occurred in recordingMiddleware', err);
              dispatch(errorOccurred(translate('DEFAULT_ERROR')));
              dispatch(cleanUp());
            },
            requestAudioOnly: state.requestAudioOnly,
            disableInMemoryRecording: state.disableInMemoryRecording
          });
          timer.start();
          break;
        case PAUSE_CLICKED:
          state.mediaRecorder.pause();
          timer.pause();
          break;
        case CONTINUE_CLICKED:
          state.mediaRecorder.resume();
          timer.resume();
          break;
        case STARTOVER_CLICKED:
        case CLEAN_UP:
        case SCREEN_SHARING_ENDED:
        case UNMOUNT_CLEAN_UP:
          if (state.mediaRecorder && state.mediaRecorder.state !== 'inactive') {
            state.mediaRecorder.stop();
          }
          timer.stop();
          break;
      }
      return next(action);
    };
  };
}